import { Stack, Typography } from '@mui/material';

import { Spacer } from 'src/components';

interface PaymentModalContentProps {
    currency: string;
    invoiceStatus: string;
    paymentMethod: string;
    createdDate: string;
    amountPaid: number;
}

const PaymentModalContent = ({
    currency,
    invoiceStatus,
    paymentMethod,
    createdDate,
    amountPaid,
}: PaymentModalContentProps) => {
    return (
        <Stack width="100%" spacing={5}>
            <Stack width="100%" flexDirection="row">
                <Typography fontWeight={600}>Status</Typography>
                <Spacer padding={1} />
                <Typography>{invoiceStatus}</Typography>
            </Stack>

            <Stack width="100%" flexDirection="row" pl={2}>
                <Typography fontWeight={600}>Method</Typography>
                <Spacer padding={1} />
                <Typography>{paymentMethod}</Typography>
            </Stack>

            <Stack width="100%" flexDirection="row" pl={2}>
                <Typography fontWeight={600}>Date</Typography>
                <Spacer padding={1} />
                <Typography>{createdDate}</Typography>
            </Stack>

            <Stack width="100%" flexDirection="row" pl={2}>
                <Typography fontWeight={600}>Amount Paid</Typography>
                <Spacer padding={1} />
                <Typography>
                    {currency}
                    {amountPaid}
                </Typography>
            </Stack>

            <Stack width="100%" flexDirection="row" justifyContent="center" alignItems="center">
                <Typography fontWeight={600}>
                    Are you sure you want to delete and un-allocate this payment?
                </Typography>
                <Spacer padding={1} />
            </Stack>
        </Stack>
    );
};
export default PaymentModalContent;
